import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      setAccountFormField // via redux actions
    } = props

    // form inputs -> Redux
    const handleChangeFormField = fieldName => event => {
      if (fieldName === 'smsOptIn') {
        setAccountFormField(fieldName, event.target.checked)
      } else {
        setAccountFormField(fieldName, event.target.value)
      }
    }

    return (
      <WrappedComponent onChangeFormField={handleChangeFormField} {...props} />
    )
  }
}

export default withEventHandlers
